import { strFromU8, decompressSync } from "fflate";

export function Decompress<T = unknown>(data: Uint8Array): T {
  return JSON.parse(strFromU8(decompressSync(data)));
}
